import React from 'react';
import Hero from './Hero';
import CreateTicket from './CreateTicket';
import './SupportPage.css';

const SupportPage = () => {
  return (
    <>
        <Hero />
        <CreateTicket />
    </>
  );
};

export default SupportPage;
